import script from "./ListViewSample.vue?vue&type=script&setup=true&lang=js"
export * from "./ListViewSample.vue?vue&type=script&setup=true&lang=js"

import "./ListViewSample.vue?vue&type=style&index=0&id=f9510e4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9510e4c"]])

export default __exports__